/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantOvertimeConfigurationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetMerchantOvertimeConfigurationResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getMerchantOvertimeConfiguration = (request: GetMerchantOvertimeConfigurationRequest, options?: CashRequestOptions) => post<GetMerchantOvertimeConfigurationRequest, GetMerchantOvertimeConfigurationResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetMerchantOvertimeConfiguration", request, {...options, rejectOnError: true })